var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "role_container" },
    [
      _c(
        "div",
        { staticClass: "sel" },
        [
          _c(
            "select-component",
            _vm._g(
              _vm._b(
                {
                  attrs: {
                    configData: _vm.configData,
                    multiple: _vm.multiple,
                    value: _vm.value
                  },
                  on: { fatherMethod: _vm.openShow }
                },
                "select-component",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        ],
        1
      ),
      _c("a-modal", {
        attrs: {
          title: "选择角色",
          dialogStyle: _vm.dialogStyle,
          width: _vm.width,
          visible: _vm.visible,
          switchFullscreen: "",
          cancelText: "关闭"
        },
        on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }